import { type FC } from 'react'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { ProductBuyBoxStickyDesktop } from './ProductBuyBoxStickyDesktop'
import { ProductBuyBoxStickyMobile } from './ProductBuyBoxStickyMobile'

export const ProductBuyBoxSticky: FC<{
  isMobile: boolean
  product: PimProductV11
}> = ({ isMobile, product }) => {
  if (isMobile) {
    return <ProductBuyBoxStickyMobile product={product} />
  }

  return <ProductBuyBoxStickyDesktop product={product} />
}
